import { createFileRoute } from "@tanstack/react-router";

import { InsiderPage } from "@/features/insights/insider";

export const Route = createFileRoute("/_authenticated/intel/insider")({
  component: InsiderPage,
});
